// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2JnwM","image":"App_image__JmkdO"};